import { z } from "zod";

export const CoverageReplacementStateSchema = z.object({
    application: z
        .object({
            state: z.string(),
        })
        .nullable(),
});
